(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-shared-layers", [], factory);
	else if(typeof exports === 'object')
		exports["map-shared-layers"] = factory();
	else
		root["map-shared-layers"] = factory();
})(self, function() {
return 